var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgMonitorIcon = function SvgMonitorIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 22",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.166 17.666H1.5a1 1 0 0 1-1-1V1.333a1 1 0 0 1 1-1h22a1 1 0 0 1 1 1v15.333a1 1 0 0 1-1 1h-9.667v2.667h4v1.333H7.166v-1.333h4zm12.001-16H1.834v14.667h21.333zM9.78 2.999c.775 0 .96 1.085 1.379 4.222.237 1.777.793 5.937 1.501 5.937.745 0 1.205-2.066 1.51-3.432.357-1.604.592-2.663 1.37-2.663s1.013 1.059 1.37 2.663c.293 1.312.729 3.268 1.422 3.422l.088.01h1.92c.265 0 .48.227.48.508a.5.5 0 0 1-.394.5l-.086.008h-1.92c-1.505 0-2.003-2.24-2.444-4.216-.126-.564-.287-1.289-.436-1.677-.149.388-.31 1.113-.436 1.677-.44 1.977-.94 4.216-2.444 4.216-1.434 0-1.902-2.697-2.452-6.81-.12-.903-.271-2.032-.425-2.754-.148.712-.291 1.814-.406 2.697-.525 4.039-.977 6.723-2.363 6.861l-.114.006H4.98a.494.494 0 0 1-.48-.508.5.5 0 0 1 .394-.5l.086-.008H6.9c.748 0 1.293-4.197 1.526-5.99C8.828 4.072 9.006 3 9.78 3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonitorIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;